let updateObjednavkyChangeTimeout;
let updateObjednavkyRequest;

window.updateObjednavky = function() {
    if (updateObjednavkyChangeTimeout) {
        clearTimeout(updateObjednavkyChangeTimeout);
    }

    if (updateObjednavkyRequest) {
        updateObjednavkyRequest.abort();
    }

    updateObjednavkyChangeTimeout = setTimeout(function () {
        const $form = $(".js-form-cart-modules");

        updateObjednavkyRequest = $.post($form.data('update-action'), $form.serialize(), function (data) {
            const shipping = data.totals.shipping;
            const payment = data.totals.payment;
            const discount = data.totals.discount;

            Cart.updates.totals(data.totals);

            if (shipping) {
                $('.js-cart-recap-shipping')
                    .removeClass('is-green')
                    .html(Format.price(shipping));
            } else {
                $('.js-cart-recap-shipping')
                    .addClass('is-green')
                    .html($('.js-cart-recap-shipping').data('free'));
            }

            if (payment) {
                $('.js-cart-recap-payment')
                    .removeClass('is-green')
                    .html(Format.price(payment));
            } else {
                $('.js-cart-recap-payment')
                    .addClass('is-green')
                    .html($('.js-cart-recap-payment').data('free'));
            }

            // $('.js-cart-recap-shipping').html(shipping ? Format.price(shipping) : $('.js-cart-recap-shipping').data('free'));
            // $('.js-cart-recap-payment').html(payment ? Format.price(payment) : $('.js-cart-recap-payment').data('free'));
            $('.js-recap-totals').html(Format.price(data.totals.total - shipping - payment - discount));
        }, "json");

        updateObjednavkyChangeTimeout = null;
    }, 100);
}

let swipers = {
    promotionProducts: {
        slider: false,
        elem: $('.js-promotion-products-shopping'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 30,
            simulateTouch: false,
            roundLengths: true,
            navigation: {
                nextEl: '.js-promotion-products-shopping-next',
                prevEl: '.js-promotion-products-shopping-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            breakpoints: {
                1199: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                1023: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
                767: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                    slidesOffsetBefore: 30,
                    slidesOffsetAfter: 30,
                    freeMode: true
                },
                599: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                    slidesOffsetBefore: 20,
                    slidesOffsetAfter: 20,
                    freeMode: true
                },
                359: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                    slidesOffsetBefore: 15,
                    slidesOffsetAfter: 15,
                    freeMode: true
                },
            },
            on: {
                init: function () {
                    swipers.promotionProducts.active = true;
                }
            }
        }
    },
}

function check_hidden_inputs(elm) {
    const $registeredInputs = $(elm).closest('form').find('input[name="registered"]');

    if (!$(elm).is(":checked")) {
        $("#" + $(elm).attr("data-box")).addClass("hide");
        $registeredInputs.val(0);
    }
    else {
        $("#" + $(elm).attr("data-box")).removeClass("hide");
        $registeredInputs.val(1);
    }
}

rEvent.on('Cart.product.after_add', function(response) {
    if (response.status) {
        window.location.reload();
    }
});

rEvent.on('Cart.product.updated', function(response) {
    if (typeof response.status !== 'undefined' && response.status) {
        location.reload();
    }
});

rEvent.on('Cart.thanks.paypal.approved', function () {
    $('#paypal-button-container').addClass('is-loading');
});

function toggleShoppingAvailability() {
    if (getCookie('shoppingAvailability')) {
        // prepnut radio buttony
        $('.js-custom-shopping-availability-radio[value="' + getCookie('shoppingAvailability') + '"]').each(function() {
            $(this).prop('checked', true);
        });

        // setnut hidden input
        $('.js-custom-shopping-availability-input').val(getCookie('shoppingAvailability'));

        // nastavit info o dodani
        $('.js-shopping-availability-toggle').each(function() {
            if ($(this).attr('data-id') == getCookie('shoppingAvailability')) {
                $(this).addClass('is-active');
            } else {
                $(this).removeClass('is-active');
            }
        });
    }
}

$(function () {
    checkSliders(swipers);
    toggleShoppingAvailability();

    rEvent.on('Window.resized', function() {
        checkSliders(swipers);
    });

    $('.js-custom-shopping-availability-radio').on('change', function() {
        setCookie('shoppingAvailability', $(this).val()), 1;

        toggleShoppingAvailability();
    });

    $('.js-form-cart-1').validate({
        submitHandler: function(form) {
            if ($('#shopping-availability-modal').length > 0 && !getCookie('shoppingAvailability')) {
                $('#shopping-availability-modal').modal('show');
            } else {
                form.submit();
            }
        }
    });

    $('.js-form-modal-availability').validate({
        errorPlacement: function (error, element) {
            if (element.attr("type").match("radio")) {
                error.insertAfter(element.parents('.c-form__item--radio'));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function(form) {
            $('.js-form-cart-1').submit();
        }
    });

    // old stuff from modules.ctp
    $('input[name="shipping_id"]').bind('change', function () {
        $('input[name="shipping_method"]').val($(this).data('name'));

        $('input[name="shipping_id"]').each(function() {
            const isChecked = $(this).is(':checked');

            for (const inputName of ['branch_id', 'shipping_module_id', 'shipping_name', 'shipping_address', 'shipping_post_code', 'shipping_city', 'shipping_phone']) {
                $(this)
                    .closest('.js-shopping-modules-item')
                    .find('input[name="' + inputName + '"]')
                    .attr('disabled', !isChecked);
            }
        });

        var payments = $(this).data('payments');
        $('input[name="payment_id"]').prop('disabled', false);
        $('input[name="payment_id"]').filter(function (index) {
            return _.indexOf(payments, parseInt($(this).val())) == -1;
        }).prop('disabled', true).prop('checked', false).trigger('change');

        if ($(this).val() != $('[name="branch_id"]').parents('.shopping-modules__item').find('[name="shipping_id"]').val()) {
            $('[name="branch_id"]:checked').prop('checked', false).trigger('change');
        }
    });

    $('.shopping-form').on('click', '.js-tigger-login-modal', function (event) {
        event.preventDefault();

        $('#login-modal').modal('show');
    });

    $('input[name="payment_id"]').on('change', function () {
        $('input[name="payment_method"]').val($(this).data('name'));
    });

    $('input[name="branch_id"], input[name="shipping_module_id"]').on('change', function () {
        if ($(this).val() && $('#error-branch').is(':visible')) {
            $('#error-branch').hide();
        }
    });

    $('input[name="shipping_id"]:checked').trigger('change');

    // modules validate
    $('.js-form-cart-modules').on('submit', function (event) {
        event.preventDefault();
    }).validate({
        errorPlacement: function (error, element) {
            if (element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
            let result = true;

            if (!$('[name="payment_id"]').is(':checked')) {
                $('#error-payment').fadeIn(500);
                result = false;
            } else {
                if ($('#error-payment').is(':visible')) { $('#error-payment').fadeOut(500); }
            }

            if (!$('[name="shipping_id"]').is(':checked')) {
                $('#error-shipping').fadeIn(500);
                result = false;
            } else {
                if ($('#error-shipping').is(':visible')) { $('#error-shipping').fadeOut(500); }

                // branch pickup
                if (
                    !$('[r-pickup-input]').val() && $('[r-pickup-input]').parents('.shopping-modules__item').find('[name="shipping_id"]').is(':checked')
                    || !$('[r-czech-post-input]').val() && $('[r-czech-post-input]').parents('.shopping-modules__item').find('[name="shipping_id"]').is(':checked')
                    || !$('[r-zasielkovna-input]').val() && $('[r-zasielkovna-input]').parents('.shopping-modules__item').find('[name="shipping_id"]').is(':checked')
                ) {
                    $('#error-branch').fadeIn(500);
                    result = false;
                }
                else {
                    if ($('#error-branch').is(':visible')) { $('#error-branch').fadeOut(500); }
                }
            }

            if (!result) {
                $('.c-msg--error:visible').slideHere();
            }

            if (result) {
                $('.js-order-submit')
                    .prop('disabled', true)
                    .addClass('is-loading');

                if (updateObjednavkyRequest) {
                    updateObjednavkyRequest.abort();
                }

                // unset branch_id if not branch is selected
                if (!$('[r-pickup-input]').parents('.shopping-modules__item').find('[name="shipping_id"]').is(':checked')) {
                    $('[r-pickup-input]').val('')
                }
                if (!$('[r-czech-post-input]').parents('.shopping-modules__item').find('[name="shipping_id"]').is(':checked')) {
                    $('[r-czech-post-input]').val('')
                }
                if (!$('[r-zasielkovna-input]').parents('.shopping-modules__item').find('[name="shipping_id"]').is(':checked')) {
                    $('[r-zasielkovna-input]').val('')
                    $('[r-zasielkovna-additional-input]').val('')
                }

                form.submit();
            }
        }
    });

    $('.js-form-cart-modules').find('input[type="radio"]').on('change', function () {
        const $form = $(".js-form-cart-modules");
        const moduleId = $(this).prop('id');
        const isShipping = $(this).prop('name') === 'shipping_id';

        if (isShipping && typeof shippingDeliveryRanges !== 'undefined' && shippingDeliveryRanges[moduleId]) {
            $('.js-cart-recap-delivery-date').html(shippingDeliveryRanges[moduleId]);
        }

        window.updateObjednavky()
    });

    // reg form
    if ($('.js-form-reg').length > 0) {
        check_hidden_inputs($("#order-registered, #customer-registered"));

        $("#order-registered, #customer-registered").change(function () {
            check_hidden_inputs($(this));
        });
    }

    // import box
    $('.js-import-box-trigger').on('click', function () {
        const $header = $('.js-import-box-header'),
            $content = $('.js-import-box-content');

        $header.slideToggle(200);
        $content.slideToggle(200);
    });

    $('.js-single-multiselect').each(function() {
        const $select = $(this);

        $select.multiselect({
            templates: {
                button: `
                    <button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown">
                    <span class="multiselect-selected-text"></span>
                    <i aria-hidden="true" class="ico ico-caret-down"></i>
                    </button>
                `,
                filter: `
                    <div class="multiselect-item multiselect-filter">
                        <div class="c-form__item c-form__item--text">
                            <input class="c-form__input multiselect-search" type="text">
                            <i class="ico ico-search"></i>
                        </div>
                    </div>
                `
            },
            enableCaseInsensitiveFiltering: true,
            buttonClass: 'c-btn c-btn--primary',
            filterPlaceholder: $select.data('filter-text'),
            enableHTML: true
        });

        requestAnimationFrame(() => {
            addMultiselectCustomData($select)
        })
    })
});

function addMultiselectCustomData($selects, options = {}) {
    $selects.each(function () {
        const $select = $(this);
        const $dropdownMenu = $select.next().find('.dropdown-menu');
        const $options = $select.find('option');

        $options.each(function () {
            const $option = $(this)
            const value = $option.val();
            const transliterate = $option.data('transliterate');
            const $fakeInput = $dropdownMenu.find('input[value="' + value + '"]');
            const $fakeInputLabel = $fakeInput.parent();

            // kvoli vyhladavaniu, aby diaktiritka bola irelevantna
            if (transliterate && !$fakeInputLabel.find('.c-transliterate').length) {
                $fakeInputLabel.append(`<span class="hidden c-transliterate">${transliterate}</span>`);
            }
        });
    });
}

// Update counter for textarea with limit
document.addEventListener('DOMContentLoaded', function () {
    const textarea = document.querySelector('.js-textarea-with-counter textarea');
    const counter = document.querySelector('.js-textarea-with-counter .js-char-count-current');

    if (textarea && counter) {
        const max = parseInt(textarea.getAttribute('maxlength'), 10) || 0;

        function updateCount() {
            counter.textContent = textarea.value.length;
        }

        textarea.addEventListener('input', updateCount);
        updateCount();
    }
});